import { render, staticRenderFns } from "./ModalBookSlot.vue?vue&type=template&id=3b504255"
import script from "./ModalBookSlot.vue?vue&type=script&lang=js"
export * from "./ModalBookSlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports